import { Component, OnInit, Output,Input ,EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import { Persona } from '../../models/Persona';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../models/messages';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-nuevo-contacto-pagare',
  templateUrl: './nuevo-contacto-pagare.component.html',
  styleUrls: ['./nuevo-contacto-pagare.component.scss'],
  providers:[Persona,MessagesTitles, MessagesStatus]
})
export class NuevoContactoPagareComponent implements OnInit {
  Id_Tipo_DNI=environment.ID_TIPO_DNI;
  @Input() IdContacto : string;
  isLinear = false;
  Titulo: string;
  editar:boolean;
  doc ='1';
  persona : Persona;
  loading:boolean=false;
  rolContactoElement : string;
  tipoDocumentoElement: number;
  disable: boolean = false;
  tipoContactoElement: any;
  user : any;
  @Output() cerrarAgregarContacto: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<boolean>();

  formularioContacto : FormGroup;
  bodyObtenerPersona = {
    'Tipo_Documento_Identidad': 'D',
    'NroDoc' : '99999999'
  }
  idEmpresa : number = 0;

  
  constructor(private empresasService : EmpresasService , 
    private routerActive:ActivatedRoute,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus,
    private loginService:LoginService) { 
    this.cerrarAgregarContacto = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Nuevo Contacto";
    this.routerActive.params.subscribe( params => {

        this.idEmpresa = this.empresasService.pagareDatos.idEmpresa; 
      
      })

      this.formularioContacto = new FormGroup({
      "docExiste" :new FormControl('1',[]),
      "idEmpresas":new FormControl(this.idEmpresa,  Validators.required),
      "Tipo_Documento_Identidad": new FormControl('',  Validators.required),
      "Nombre_de_Contacto": new FormControl('',  Validators.required),
      "Nro_Documento_Identidad": new FormControl('',  Validators.required),
      "Apellido_Paterno": new FormControl('',  Validators.required),
      "Apellido_Materno":new FormControl('',  Validators.required),
      "Nombre1":new FormControl('',  Validators.required),
      "Nombre2": new FormControl('',  Validators.required),
      "NroMovil_Laboral": new FormControl('',  Validators.required),
      "NroFijo_Laboral":new FormControl('',  Validators.required),
      "Anexo":new FormControl('',Validators.maxLength(6)),
      "Correo": new FormControl('',  Validators.required),
      "Direccion":new FormControl('',  Validators.required),
      "Distrito":new FormControl('',  Validators.required),
      "Tipo_de_Contacto": new FormControl(this.tipoContactoElement,  Validators.required),
      "Rol_del_Contacto":new FormControl(this.rolContactoElement,  Validators.required),
      "Condicion":new FormControl('3',  Validators.required),
      "Contrasena":new FormControl(null),
      "Fecha_Contrasena": new FormControl(null),
      "Adjunto_Vigencia_Poder": new FormControl(null),
      "Adjunto_DNI":new FormControl(null),
      "Fecha_Adjuntos":new FormControl(null),
      "Usuario": new FormControl(this.user.Usuario)
    });
    
  }

  ngOnInit() {
    
    this.validarDocumentoExiste(this.doc);

  }

  tipoDocumento(event){
    this.formularioContacto.controls['Tipo_Documento_Identidad'].setValue(event);
  }

tipoContacto(event){
    this.formularioContacto.controls['Tipo_de_Contacto'].setValue(event)
  }

  rolContacto(event){
    this.formularioContacto.controls['Rol_del_Contacto'].setValue(event)
  }

  crearContacto(){
    
    this.loading=true;
    this.formularioContacto.controls['Nombre_de_Contacto'].setValue( this.formularioContacto.controls['Apellido_Paterno'].value +', '
    +this.formularioContacto.controls['Nombre1'].value)
      
      this.empresasService.agregarContacto(this.formularioContacto.getRawValue())
            .subscribe(res => {
                this.loading=false;
                Swal.fire({
                  title: "¡Éxito!",
                  text: 'Contacto registrado correctamente.',
                  type: "success",
                  allowOutsideClick: false,
                  heightAuto: false
                }).then( resp => {
      
                  if (resp.value == true){
                    this.loginService.clickGuard = true;
                    this.refresh.emit();
                    this.cerrarAgregarContacto.emit();     
                  }
                });
            },(err: HttpErrorResponse)=> {
              this.loading=false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
            } else {
                this.msgStatus.getMessage(err.status);            
            }
              Swal.fire({
                title: this.msgTitulos.Error,
                text: "CONTACTO NO REGISTRADO. "+this.msgStatus.message ,
                type: "error",
                allowOutsideClick: true,
                heightAuto: false
              })
            })
  }

  CerrarPopUp(){
    this.cerrarAgregarContacto.emit();
  }

  validarDocumentoExiste(valor : string){

    if (this.doc == '1'){
      this.formularioContacto.controls['Tipo_Documento_Identidad'].enable();
      this.formularioContacto.controls['Nro_Documento_Identidad'].enable();
      this.formularioContacto.controls['Apellido_Paterno'].disable();
      this.formularioContacto.controls['Apellido_Materno'].disable();
      this.formularioContacto.controls['Nombre1'].disable();
      this.formularioContacto.controls['Nombre2'].disable();
      this.tipoDocumentoElement = 0;
      this.disable = false;
    }else{
      this.formularioContacto.controls['Tipo_Documento_Identidad'].disable();
      this.formularioContacto.controls['Nro_Documento_Identidad'].setValue(99999999);
      this.formularioContacto.controls['Nro_Documento_Identidad'].disable();      
      this.formularioContacto.controls['Apellido_Paterno'].enable();
      this.formularioContacto.controls['Apellido_Materno'].enable();
      this.formularioContacto.controls['Nombre1'].enable();
      this.formularioContacto.controls['Nombre2'].enable();
      this.disable = true;
      this.tipoDocumentoElement = this.Id_Tipo_DNI;
      this.bodyObtenerPersona.NroDoc="";
      this.formularioContacto.controls['Tipo_Documento_Identidad'].setValue(this.Id_Tipo_DNI);
    }

  }

  asignarDatosPersona( persona : Persona){

    this.formularioContacto.controls['Apellido_Paterno'].setValue( persona.ApellidoPaterno);
    this.formularioContacto.controls['Apellido_Materno'].setValue(persona.ApellidoMaterno);
    this.formularioContacto.controls['Nombre1'].setValue(persona.PrimerNombre);
    this.formularioContacto.controls['Nombre2'].setValue(persona.SegundoNombre);
  
  }

  obtenerPersona(){


    this.loading=true;

    this.empresasService.obtenerPersonaRiesgo(this.bodyObtenerPersona)
          .subscribe( res => {
            this.persona = res as Persona;
            this.asignarDatosPersona(this.persona);
            this.loading=false;
          },(err: HttpErrorResponse)=> {
            this.loading=false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
          } else {
              this.msgStatus.getMessage(err.status);            
          }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "DATOS NO OBTENIDO. "+this.msgStatus.message ,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })

  }
}
